import { css } from 'emotion';

export const progressBarAlert = (color: string, duration: number) => css`
  height: 6px;
  background: ${color};
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 1px 1px 5px 5px;
  animation: progressBarAnimation ${duration}ms;
  animation-timing-function: ease-in-out;

  @keyframes progressBarAnimation {
    from {
      width: 100%;
    }
    to {
      width: 0%;
    }
  }
`;
